import { configureStore } from '@reduxjs/toolkit';
import calendarReducer from './calendar';
import communicatorReducer from './communicator';
import contactReducer from './contact';
import ConversationReducer from './conversation';
import ConversationGridReducer from './conversationGrid';
import dialerReducer from './dialer';
import inboxReducer from './inbox';
import mediaReducer from './media';
import { dialerListenerMiddleware } from './middleware/dialerMiddleware';
import websocketMiddleware from './middleware/websocketMiddleware';
import notifyReducer from './notify';
import sidebarDrawerReducer from './sidebarDrawer';
import userReducer from './users';
import viewReducer from './views';
import websocketReducer from './websocket';

const reducer = {
    user: userReducer,
    view: viewReducer,
    notify: notifyReducer,
    inbox: inboxReducer,
    communicator: communicatorReducer,
    conversation: ConversationReducer,
    conversationGrid: ConversationGridReducer,
    calendar: calendarReducer,
    websocket: websocketReducer,
    contact: contactReducer,
    media: mediaReducer,
    sidebarDrawer: sidebarDrawerReducer,
    dialer: dialerReducer,
};

const middleware = [dialerListenerMiddleware.middleware, websocketMiddleware];

const store = configureStore({
    reducer,
    preloadedState: {},
    middleware: getDefaultMiddleware => {
        return getDefaultMiddleware().concat(middleware);
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
